module.exports = __webpack_public_path__ + "static/media/web-based2.a3d7f03b.png";